import { Injectable, inject, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CsrWebApiService } from '../../../../csr-web-api.service';
import { AdminCareerChallengeDetailResponse } from '../../../../models';

@Injectable({ providedIn: 'root' })
export class CareerChallengeAdminStore {
  private readonly api = inject(CsrWebApiService);
  readonly challenge = signal<AdminCareerChallengeDetailResponse | null>(null);
  readonly loading = signal(false);
  readonly error = signal('');
  private loadedId = '';

  async load(id: string, force = false): Promise<AdminCareerChallengeDetailResponse | null> {
    if (!id) {
      return null;
    }
    if (!force && this.loadedId === id && this.challenge()) {
      return this.challenge();
    }
    this.loading.set(true);
    this.error.set('');
    try {
      const detail = await firstValueFrom(this.api.getAdminCareerChallenge(id));
      this.challenge.set(detail);
      this.loadedId = id;
      return detail;
    } catch {
      this.error.set('Could not load career challenge.');
      this.challenge.set(null);
      return null;
    } finally {
      this.loading.set(false);
    }
  }

  clear(): void {
    this.challenge.set(null);
    this.loadedId = '';
    this.error.set('');
  }
}
